import React from 'react';

import { sendRequest } from './global.js';

var LoginForm = React.createClass({
  getInitialState: function() {
    return {username: '', password: ''};
  },
  handleUsernameChange: function(e) {
    this.setState({username: e.target.value});
  },
  handlePasswordChange: function(e) {
    this.setState({password: e.target.value});
  },
  handleSubmit: function(e) {
    e.preventDefault();
    var username = this.state.username.trim();
    var password = this.state.password.trim();
    if (!username || !password) {
      return;
    }
    var loginData = {
      username: username,
      password: password,
      grant_type: "password",
    }
    sendRequest({
      auth: true,
      method: "oauth/token",
      type: "POST",
      data: loginData,
      success: function(data) {
        localStorage.setItem("access_token", data.access_token);
        this.props.onLogin();
      }.bind(this),
      error: function(xhr, status, err) {
        this.setState({password: ''});
      }.bind(this)
    });
  },
  render: function() {
    return (
      <div className="loginPage">
        <div className="col-sm-offset-1 col-sm-5">
          <div className="col-sm-offset-2 col-sm-10">
            <h1 className="page-header">Вход</h1>
          </div>
          <form className="form-horizontal loginForm" onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="username" className="col-sm-2 control-label">Email</label>
              <div className="col-sm-10">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Email"
                  value={this.state.username}
                  onChange={this.handleUsernameChange}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="password" className="col-sm-2 control-label">Пароль</label>
              <div className="col-sm-10">
                <input 
                  type="password" 
                  className="form-control" 
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handlePasswordChange}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button 
                  type="submit" 
                  value="Post"
                  className="btn btn-default"
                >Войти</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
});

export default LoginForm;



// WEBPACK FOOTER //
// ./src/LoginForm.js